import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getLibraryPageDownloadsData = async () => {
  const data = await fetchData(ENDPOINTS.GET.LBRARY_PAGE_DOWNLOADS, {
    method: METHODS.GET,
  });
  return data;
};
